// extracted by mini-css-extract-plugin
export default {"card":"user-card_card__HEgIU","UserAvatar":"user-card_UserAvatar__h1stj","email":"user-card_email__E2wW0"};